<template>
  <div class="home">   

    <wellaiapi />
    
  </div>
</template>

<style scoped lang="sass">

 

</style>

<script>

import wellaiapi from '@/components/common/wellaiapi/index.vue'


export default {
  name: 'home',
  components: {
    wellaiapi
  },

  methods : {
    
  }
}
</script>
